import { HTTPVerbs, type RequestOptions } from '@nextgen-web-framework/core';

export function getUserCouponsReqObj(): RequestOptions {
  return {
    url: '/comindexedcouponas/v1/coupons-search',
    method: HTTPVerbs.GET,
    retries: 0,
  };
}
